export default [
    {
        path: '/services',
        name: 'services',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Services.vue')
    }
]